<template>
	<v-col class="registrasi">
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<template v-if="!loaderData">
			<div v-show="!isSuccessReg">
				<div class="d-flex justify-space-between">
					<div class="text-h6 cl-primary">{{ pageTitle }}</div>
				</div>
				<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
					<router-link to="/">
						<div class="d-flex">
							<v-icon small color="grey">mdi-home</v-icon>
							<div class="pl-2 grey--text">Dashboard</div>
						</div>
					</router-link>

					<div class="px-2">/</div>
					<div>Jaringan</div>
					<div class="px-2">/</div>
					<div>{{ pageTitle }}</div>
				</div>

				<template v-if="!allowedClone.clone">
					<v-alert
						border="bottom"
						color="red lighten-1"
						dark
						class="pa-7 mt-5"
					>
						<v-row justify-center>
							<v-col cols="12" xs="12" sm="2" md="1">
								<v-icon
									x-large
									color="white"
									style="font-size: 64px!important;"
								>mdi-alert-circle</v-icon>
							</v-col>

							<v-col cols="12" xs="12" sm="10" md="11" style="padding-top: 20px!important;">
								Anda telah melakukan <b>Kloning Akun</b> pada periode bulan ini.<br>Anda dapat melakukan registrasi Kloning Akun Anda kembali pada <b>{{ allowedClone.next_clone | tanggaljam }}</b>.
							</v-col>
						</v-row>
					</v-alert>

					<v-row>
						<v-col cols="12" sm="12" md="6" class="d-flex justify-start justify-sm-start justify-md-start mt-4">
							<v-btn color="grey lighten-2" class="rounded-lg text-capitalize mx-1 rounded-pill" @click="goDashboard">
								<v-icon dense>mdi-home</v-icon>
								<span class="ml-2">Kembali ke Beranda</span>
							</v-btn>
							<v-btn color="grey lighten-2" class="rounded-pill rounded-lg text-capitalize mx-1" @click="goGenealogy">
								<v-icon dense>mdi-account-network</v-icon>
								<span class="ml-2">Lihat Jaringan Saya</span>
							</v-btn>
						</v-col>
					</v-row>
				</template>

				<template v-else>
					<template v-if="isMitraExist">
						<div class="mt-5">
							<v-row>
								<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
									<v-col cols="12" sm="12" md="4" class="align-stretch pt-5">
										<v-form ref="formCloningAccount" role="form" autocomplete="off">
											<v-row>
												<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3">
													<v-card class="pa-4 elevation-0 rounded-lg" outlined>
														<div class="font-size-14 cl-primary">Data Jaringan &amp; Serial</div>

														<div class="pt-2 mb-0 mt-2">
															<v-text-field
																label="Kode Sponsor"
																color="primary"
																hide-details="auto"
																class="input-regis"
																prepend-inner-icon="mdi-account-tie-voice-outline"
																v-model="params.sponsor_network_code"
																tabindex="0"
																outlined
																dense
																ref="sponsor_network_code"
																:rules="rules.sponsor_code"
																@focus="$event.target.select()"
																@keyup="(params.sponsor_network_code) ? params.sponsor_network_code = params.sponsor_network_code.toUpperCase() : params.sponsor_network_code"
																@blur="getMitraSponsorName(params.sponsor_network_code, 'input')"
																:error-messages="(errorValidation !== undefined && errorValidation['sponsor_network_code'] !== undefined ) ? [errorValidation['sponsor_network_code']] : []"
															>
															</v-text-field>
															<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="sponsor_valid">
																{{ sponsor_name }}
															</div>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																label="Kode Upline"
																ref="upline_network_code"
																color="primary"
																hide-details="auto"
																class="input-regis"
																prepend-inner-icon="mdi-account-network-outline"
																v-model="params.upline_network_code"
																tabindex="1"
																outlined
																dense
																:rules="rules.upline_code"
																@focus="$event.target.select()"
																@keyup="(params.upline_network_code) ? params.upline_network_code = params.upline_network_code.toUpperCase() : params.upline_network_code"
																@blur="getMitraUplineName(params.upline_network_code, 'input')"
																:error-messages="(errorValidation !== undefined && errorValidation['upline_network_code'] !== undefined ) ? [errorValidation['upline_network_code']] : []"	
															>
															</v-text-field>
															<div class="pt-1 font-size-9" :class="(upline_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'" v-if="upline_valid">
																{{ upline_name }}
															</div>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-autocomplete 
																label="Pilih Posisi Jaringan" 
																hide-details="auto" 
																no-data-text="Tidak ada data" 
																outlined
																dense
																color="primary" 
																:items="listPosition" 
																item-text="label" 
																item-value="value" 
																ref="position" 
																v-model="params.position" 
																:rules="[rules.inputreq('Posisi Jaringan', params.position)]"
																:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
																tabindex="2">
																<template v-slot:selection="data">
																	<v-icon dense v-if="data.item.value === 'L'" style="-webkit-transform: scaleX(-1);transform: scaleX(-1);">mdi-account-arrow-right</v-icon>
																	<v-icon dense v-else>mdi-account-arrow-right-outline</v-icon>
																	<span class="cl-dark ml-3">{{ data.item.label }}</span>
																</template>
															</v-autocomplete>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																label="Serial Registrasi"
																color="primary"
																class="input-regis"
																hide-details="auto"
																ref="serial_id"
																outlined
																dense
																prepend-inner-icon="mdi-credit-card-scan-outline"
																v-model="params.serial_id"
																tabindex="3"
																@keyup="(params.serial_id) ? params.serial_id = params.serial_id.toUpperCase() : params.serial_id"
																:error-messages="(errorValidation !== undefined && errorValidation['serial_id'] !== undefined ) ? [errorValidation['serial_id']] : []"
																:rules="[rules.inputreq('Nomor Serial Registrasi', params.serial_id)]"></v-text-field>	
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																ref="serialpin"
																label="PIN Serial Registrasi"
																color="primary"
																class="input-regis"
																prepend-inner-icon="mdi-credit-card-lock-outline"
																v-model="params.serial_pin"
																hide-details="auto"
																:type="typeInputSerial"
																:append-icon="iconSerial"
																@click:append="showSerial"
																outlined
																dense
																tabindex="4"
																:error-messages="(errorValidation !== undefined && errorValidation['serial_pin'] !== undefined ) ? [errorValidation['serial_pin']] : []"
																:rules="rules.serialpin"></v-text-field>
														</div>
													</v-card>
												</v-col>
											</v-row>

											<v-row v-if="false">
												<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3">
													<v-card class="pa-4 elevation-0 rounded-lg" outlined>
														<div class="font-size-14 cl-primary">Akun Mitra</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																label="Username"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																outlined
																dense
																ref="username"
																v-model="params.username"
																tabindex="4"
																:error-messages="(errorValidation !== undefined && errorValidation['username'] !== undefined ) ? [errorValidation['username']] : []"
																:rules="[rules.inputreq('Username', params.username)]"></v-text-field>	
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field 
																label="Password"
																color="primary"
																class="input-regis"
																prepend-inner-icon="mdi-key-variant"
																v-model="params.password"
																hide-details="auto"
																:type="typeInput"
																:append-icon="icon"
																@click:append="showPassword"
																outlined
																dense
																tabindex="5"
																:error-messages="(errorValidation !== undefined && errorValidation['password'] !== undefined ) ? [errorValidation['password']] : []"
																:rules="rules.password"></v-text-field>
														</div>
													</v-card>
												</v-col>
											</v-row>

											<v-row>
												<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3">
													<v-card class="pa-4 elevation-0 rounded-lg" outlined>
														<div class="font-size-14 cl-primary">Alamat Pengiriman</div>

														<div class="pa-2 mt-2" style="border: 1px solid #999;">
															<v-checkbox
																v-model="isEqualAddress"
																class="ma-0"
																style="margin-bottom: -5px!important;"
																tabindex="6"
																@change="setReceiverAddress()"
															>
																<template slot="label">
																	<span class="d-flex align-center">
																		Gunakan alamat utama sebagai alamat tujuan pengiriman.
																	</span>
																</template>
															</v-checkbox>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																label="Nama Penerima"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																outlined
																dense
																ref="receiver_name"
																v-model="params.receiver_name"
																tabindex="7"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_name'] !== undefined ) ? [errorValidation['receiver_name']] : []"
																:rules="[rules.inputreq('Nama Penerima', params.receiver_name)]"></v-text-field>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-text-field
																label="Nomor Handphone Penerima"
																color="primary"
																class="input-regis"
																prepend-inner-icon="mdi-cellphone"
																v-model="params.receiver_mobilephone"
																hide-details="auto"
																maxlength="15"
																:rules="rules.nohp"
																outlined
																dense
																ref="receiver_mobilephone"
																tabindex="8"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_mobilephone'] !== undefined ) ? [errorValidation['receiver_mobilephone']] : []"
																@keypress="onlyNumber"
																@paste.prevent></v-text-field>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-textarea
																name="receiver_address"
																label="Alamat"
																v-model="params.receiver_address"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-radius-outline"
																counter="255"
																maxlenght="255"
																rows="3"
																outlined
																dense
																tabindex="9"
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Alamat Pengiriman', params.receiver_address)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_address'] !== undefined ) ? [errorValidation['receiver_address']] : []"
															></v-textarea>	
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-autocomplete
																label="Provinsi"
																no-data-text="Tidak ada data"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="province"
																item-text="province_name"
																item-value="province_id"
																v-model="params.receiver_province_id"
																tabindex="10"
																outlined
																dense
																class="mb-3"
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Provinsi Pengiriman', params.receiver_province_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_province_id'] !== undefined ) ? [errorValidation['receiver_province_id']] : []"
																@change="changeProvinceReceiver"></v-autocomplete>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-autocomplete
																label="Kota"
																no-data-text="Pilih Provinsi Dahulu"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="city"
																item-text="city_name"
																item-value="city_id"
																v-model="params.receiver_city_id"
																outlined
																dense
																tabindex="11"
																class="mb-3"
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Kota/Kabupaten Pengiriman', params.receiver_city_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_city_id'] !== undefined ) ? [errorValidation['receiver_city_id']] : []"
																@change="changeCityReceiver">
																	<template v-slot:item="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																	<template v-slot:selection="data">
																		<span class="cl-dark">{{ data.item.city_type + ' ' + data.item.city_name }}</span>
																	</template>
																</v-autocomplete>
														</div>

														<div class="pt-2 pb-0 mt-2">
															<v-autocomplete
																label="Kecamatan"
																no-data-text="Tidak ada data"
																color="primary"
																hide-details="auto"
																prepend-inner-icon="mdi-map-marker-right-outline"
																:items="subdistrict"
																item-text="subdistrict_name"
																item-value="subdistrict_id"
																v-model="params.receiver_subdistrict_id"
																tabindex="12"
																outlined
																:disabled="isEqualAddress"
																:rules="[rules.inputreq('Kecamatan Pengiriman', params.receiver_subdistrict_id)]"
																:error-messages="(errorValidation !== undefined && errorValidation['receiver_subdistrict_id'] !== undefined ) ? [errorValidation['receiver_subdistrict_id']] : []"
																dense></v-autocomplete>
														</div>
													</v-card>
												</v-col>
											</v-row>

											<v-card class="pa-3 my-4 elevation-0 rounded-lg" outlined>
												<div class="d-flex flex-row justify-space-between">
													<v-btn text class="mr-2" :loading="btnLoading" @click="goBack()" tabindex="14">
														<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
													</v-btn>

													<v-btn
														color="primary"
														tabindex="13"
														:loading="btnLoading"
														@click="processInput()"
													>
														<v-icon dense class="mr-1">mdi-account-box-multiple-outline</v-icon>
														Kloning Akun
													</v-btn>
												</div>
											</v-card>
										</v-form>
									</v-col>
								</v-scroll-x-reverse-transition>

								<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
									<v-col cols="12" sm="12" md="8" class="pt-5">
										<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
											<div class="font-size-12 cl-primary">Data Personal</div>
											<div class="pt-5">
												<v-row>
													<v-col cols="12" sm="12" md="3">
														<div class="text-center">
															<v-img height="100" width="100" class="user-img mx-auto rounded-pill" :src="(stores_image) ? stores_image : 'assets/image/profile-pict.png'"></v-img>
															<div class="bottom-shadow"></div>
														</div>
													</v-col>
													<v-col cols="12" sm="12" md="4" class="px-4">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Lengkap</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.name | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account-outline</v-icon>Jenis Kelamin</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.gender | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-radius-outline</v-icon>Tempat/Tanggal Lahir</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.birth_place | emptyData }}, {{ params.birth_date | tanggal }}</span>
															</div>
														</div>
														
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-card-account-details</v-icon>No. Identitas <span v-if="params.identity_type" class="d-inline-block pl-2 font-weight-bold"> ( {{ params.identity_type }} )</span></span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.identity_no | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-email</v-icon>Email</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.email | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-cellphone</v-icon>No. Handphone</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mobilephone | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="5" class="px-4">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-radius-outline</v-icon>Alamat</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.address | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kecamatan</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.subdistrict_name | emptyData }}</span>
															</div>
														</div>
														
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota/Kabupaten</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.city_name | emptyData }}</span>
															</div>
														</div>

														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Provinsi</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.province_name | emptyData }}</span>
															</div>
														</div>
													</v-col>
												</v-row>
											</div>
										</v-card>
										
										<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
											<div class="font-size-12 cl-primary">Data Ahli Waris</div>
											<div class="pt-5">
												<v-row>
													<v-col cols="12" sm="12" md="12" class="px-0">
														<div class="d-block font-size-10 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ibu Kandung</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.mother_name | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Ahli Waris</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_name | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Hubungan Ahli Waris</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_relation | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-cellphone</v-icon>No. HP Ahli Waris</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.devisor_mobilephone | emptyData }}</span>
															</div>
														</div>
													</v-col>
												</v-row>
											</div>
										</v-card>

										<v-card class="pa-4 elevation-0 rounded-lg mb-2" outlined>
											<div class="font-size-12 cl-primary">Data Bank</div>
											<div class="pt-5">
												<v-row>
													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account</v-icon>Nama Pemilik Rekening</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_name | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-account-box-outline</v-icon>Nomor Rekening</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.account_no | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-bank-outline</v-icon>Nama Bank</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_name | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Kota Bank</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_city_id | emptyData }}</span>
															</div>
														</div>
													</v-col>

													<v-col cols="12" sm="12" md="4" class="px-0">
														<div class="d-block font-size-10 mb-3 px-2">
															<div class="d-flex flex-column">
																<span class="d-flex align-center grey--text"><v-icon small class="mr-2" color="grey">mdi-map-marker-right-outline</v-icon>Nama Cabang</span>
																<span class="font-weight-600 cl-secondary text-capitalize pl-6">{{ params.bank_branch_name | emptyData }}</span>
															</div>
														</div>
													</v-col>
												</v-row>
											</div>
										</v-card>
									</v-col>
								</v-scroll-x-reverse-transition>
							</v-row>
						</div>
					</template>

					<template v-else>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-lg text-center">
									<NoData></NoData>
									<div class="d-block py-3 text-center cl-secondary">Data Mitra tidak dapat ditemukan.</div>
									<v-btn text class="my-4" :loading="btnLoadingProses" @click="goBack()">
										<v-icon dense class="mr-1">mdi-arrow-left</v-icon> Kembali
									</v-btn>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</template>
			</div>

			<template v-if="isSuccessReg">
				<ReportRegistrasi :data="tempRegister" :voUrlHost="voUrlOrigin" :voUrlOrigin="voUrlOrigin"></ReportRegistrasi>
			</template>
		</template>

		<template v-else>
			<LoadData :loading="loaderData"></LoadData>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSuccess from './components/ModalSuccessCloning'
import ReportRegistrasi from '@/components/layout/vo/ReportRegistrasi'

export default {
	components: {
		ModalSuccess, ReportRegistrasi
	},

	data() {
		return {
			loaderData: false,
			loading: false,
			isSuccessReg: false,
			typeInput: 'password',
			typeInputSerial: 'password',
			icon: 'mdi-eye',
			iconSerial: 'mdi-eye',
			btnLoadingProses: false,
			btnLoading: false,
			suksesInput: false,
			isActiveMember: true,
			isMitraExist: true,
			stores_image: null,
			paramsId: null,
			pageTitle: '',
			sponsor_name: '',
			sponsor_valid: true,
			upline_name: '',
			upline_valid: true,
			tempRegister: null,
			voUrlOrigin: '',
			voUrlHost: '',
			isEqualAddress: false,
			params: {
				member_id: '',
				sponsor_network_code: '',
				upline_network_code: '',
				position: 'L',
				serial_id: '',
				serial_pin: '',
				username: '',
				password: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				identity_image: null,
				mobilephone: '',
				gender: '',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				subdistrict_name: '',
				city_id: '',
				city_name: '',
				province_id: '',
				province_name: '',
				country_id: '102',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				receiver_name: '',
				receiver_mobilephone: '',
				receiver_address: '',
				receiver_subdistrict_id: '',
				receiver_city_id: '',
				receiver_province_id: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				devisor_mobilephone: ''
			},
			listPosition: [
				{
					label: 'Kanan',
					value: 'R'
				},
				{
					label: 'Kiri',
					value: 'L'
				}
			],
			listGender: [
				{
					label: 'Laki-laki',
					value: 'Laki-laki'
				},
				{
					label: 'Perempuan',
					value: 'Perempuan'
				}
			],
			rules: {
				input: [
					v => !!v || 'Tidak boleh kosong',
				],
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
				serialpin: [
					v => !!v || 'PIN Serial tidak boleh kosong'
				],
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
				password: [
					v => !!v || 'Password Tidak boleh kosong',
					v => ( v && v.length >= 6 ) || 'Password tidak boleh kurang dari 6 karakter',
				],
				nohp: [
					v => !!v || 'Nomor Handphone tidak boleh kosong',
					v => ( v && v.length <= 16 ) || "Nomor Handphone tidak boleh lebih dari 16 angka",
					v => ( v && v.length > 10 ) || "Nomor Handphone tidak boleh kurang dari 10 angka",
				]
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},

	watch: {
	},

	computed: {
		...mapState('auth', ['userData']),
		...mapState('registration', ['responSuksesRegis', 'responseError', 'errorValidation']),
		...mapState('profile', ['myProfile', 'myBank']),
		...mapState('option', ['province', 'city', 'subdistrict', 'bank', 'listBankCities']),
		...mapState('network', ['allowedClone']),
	},
	methods: {
		...mapActions('registration', ['getMitraByNetworkCode', 'addCloneMitra']),
		...mapActions('option', ['getProvince', 'getCity', 'getSubdistrict', 'getBank', 'getBankCity']),
		...mapActions('profile', ['getProfileMitra']),
		...mapActions('network', ['checkCloneStatus']),

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		showSerial() {
			this.typeInputSerial = this.typeInputSerial == 'text' ? 'password' : 'text'
			this.iconSerial = this.iconSerial == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		changeProvinceReceiver() {
			this.getCity({ province_id: this.params.receiver_province_id	})
			this.params.receiver_city_id = ''
			this.params.receiver_subdistrict_id = ''
		},

		changeCityReceiver() {
			this.getSubdistrict({ city_id: this.params.receiver_city_id	})
			this.params.receiver_subdistrict_id = ''
		},

		setReceiverAddress() {
			if (this.isEqualAddress) {
				this.params.receiver_address = this.params.address
				this.params.receiver_province_id = this.params.province_id
				this.changeProvinceReceiver()
				this.params.receiver_city_id = this.params.city_id
				this.changeCityReceiver()
				this.params.receiver_subdistrict_id = this.params.subdistrict_id
				this.params.receiver_name = this.params.name
				this.params.receiver_mobilephone = this.params.mobilephone
			} else {
				this.params.receiver_address = ''
				this.params.receiver_province_id = ''
				this.params.receiver_city_id = ''
				this.params.receiver_subdistrict_id = ''
				this.params.receiver_name = ''
				this.params.receiver_mobilephone = ''
			}
		},

		reset() {
			this.isEqualAddress = false
			this.params = {
				member_id: '',
				sponsor_network_code: '',
				upline_network_code: '',
				position: 'L',
				serial_id: '',
				serial_pin: '',
				username: '',
				password: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				identity_image: null,
				mobilephone: '',
				gender: 'Laki-laki',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				subdistrict_name: '',
				city_id: '',
				city_name: '',
				province_id: '',
				province_name: '',
				country_id: '102',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_branch: '',
				bank_province_id: '',
				bank_city: '',
				receiver_name: '',
				receiver_mobilephone: '',
				receiver_address: '',
				receiver_subdistrict_id: '',
				receiver_city_id: '',
				receiver_province_id: '',
				mother_name: '',
				devisor_name: '',
				devisor_relation: '',
				devisor_mobilephone: ''
			}
		},

		getMitraSponsorName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						if (trigger === 'input') {
							this.sponsor_name = '[' + response.data.member_name + ']'
							this.sponsor_valid = true

							setTimeout(() => {
								if (this.$refs.upline_network_code !== undefined) this.$refs.upline_network_code.focus()
							}, 200);
						}
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							if (this.$refs.sponsor_network_code !== undefined)  this.$refs.sponsor_network_code.focus()
						}, 200);
					}
					
				}).catch(() => {
					this.sponsor_name = ''
					this.sponsor_valid = false
					setTimeout(() => {
						this.$refs.formCloningAccount.validate()
					}, 1000);
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		getMitraUplineName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMitraByNetworkCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response.data).length > 0) {
						this.upline_name = '[' + response.data.member_name + ']'
						this.upline_valid = true

						if (trigger === 'input' && this.$route.query.upline === undefined) {
							setTimeout(() => {
								this.$refs.position.focus()
							}, 200);
						}
					} else {
						this.upline_name = ''
						this.upline_valid = false
						setTimeout(() => {
							if (this.$refs.upline_network_code !== undefined) this.$refs.upline_network_code.focus()
						}, 200);
					}
				}).catch(() => {
					this.upline_name = ''
					this.upline_valid = false
					setTimeout(() => {
						this.$refs.formCloningAccount.validate()
					}, 1000);
				})
			} else {
				this.upline_name = ''
				this.upline_valid = false
			}
		},

		async getProfileData() {
			this.isMitraExist = true
			this.stores_image = this.myProfile.member_image_url

			this.params = {
				sponsor_network_code: this.$route.query.sponsor,
				upline_network_code: this.$route.query.upline,
				position: this.$route.query.pos,

				member_id: this.myProfile.member_id,
				name: this.myProfile.member_name,
				username: this.myProfile.member_name,
				identity_no: this.myProfile.member_identity_no,
				identity_type: this.myProfile.member_identity_type,
				email: this.myProfile.member_email,
				mobilephone: this.myProfile.member_mobilephone,
				gender: this.myProfile.member_gender,
				birth_place: this.myProfile.member_birth_place,
				birth_date: this.myProfile.member_birth_date,
				subdistrict_id: this.myProfile.member_subdistrict_id,
				subdistrict_name: this.myProfile.member_subdistrict_name,
				city_id: this.myProfile.member_city_id,
				city_name: this.myProfile.member_city_name,
				province_id: this.myProfile.member_province_id,
				province_name: this.myProfile.member_province_name,
				address: this.myProfile.member_address,

				receiver_name: this.myProfile.receiver_name,
				receiver_mobilephone: this.myProfile.receiver_mobilephone,
				receiver_address: this.myProfile.receiver_address,
				receiver_subdistrict_id: this.myProfile.receiver_subdistrict_name,
				receiver_city_id: this.myProfile.receiver_city_name,
				receiver_province_id: this.myProfile.receiver_province_name,

				bank_id: this.myProfile.member_bank_id,
				bank_name: this.myProfile.member_bank_name,
				bank_branch_name: this.myProfile.member_bank_branch,
				bank_city_id: this.myProfile.member_bank_city,
				account_name: this.myProfile.member_bank_account_name,
				account_no: this.myProfile.member_bank_account_no,

				mother_name: this.myProfile.member_mother_name,
				devisor_name: this.myProfile.member_devisor_name,
				devisor_relation: this.myProfile.member_devisor_relation,
				activation_datetime: this.myProfile.member_activation_datetime,
				devisor_mobilephone: this.myProfile.member_devisor_mobilephone
				// bank_city_name: '',
				// bank_province_id: '',
			}
		},

		async getData() {
			await this.getProfileMitra()
			await this.getProfileData()
			await this.getProvince()
			await this.getCity()
			// await this.getSubdistrict()

			setTimeout(() => {
				this.loaderData = false
			}, 600);
		},

		goBack() {
			this.$router.push({name: 'genealogy'})
		},

		goGenealogy() { this.$router.push({name: 'genealogy'}) },
		goDashboard() { this.$router.push({name: 'dashboard'}) },

		async processInput() {
			this.btnLoading = await true
			if (this.$refs.formCloningAccount.validate()) {

				let paramClone = []
				if (this.isEqualAddress) {
					paramClone = await {
						serial_id: this.params.serial_id,
						serial_pin: this.params.serial_pin,
						upline_network_code: this.params.upline_network_code,
						sponsor_network_code: this.params.sponsor_network_code,
						position: this.params.position
					}
				} else {
					paramClone = await {
						serial_id: this.params.serial_id,
						serial_pin: this.params.serial_pin,
						upline_network_code: this.params.upline_network_code,
						sponsor_network_code: this.params.sponsor_network_code,
						position: this.params.position,
						receiver_name: this.params.receiver_name,
						receiver_mobilephone: this.params.receiver_mobilephone,
						receiver_address: this.params.receiver_address,
						receiver_subdistrict_id: this.params.receiver_subdistrict_id,
						receiver_city_id: this.params.receiver_city_id,
						receiver_province_id: this.params.receiver_province_id
					}
				}

				// console.log('paramClone', paramClone)

				this.addCloneMitra(paramClone).then((response) => {
					this.typeRegis = 'mitra'
					this.tempRegister = response.results.data
					this.isSuccessReg = true
					setTimeout(() => {
						// this.reset()
						this.upline_name = ''
						this.sponsor_name = ''
						this.btnLoading = false
					}, 600);
				}).catch(() => {
					this.btnLoading = false
				})
				this.btnLoading = await false
			} else {
				this.btnLoading = false
			}
		},

		successCloning(data) {
			if(data) {
				this.msgSuccess = `
					<span class="font-weight-bold cl-primary font-size-12">Akun Mitra Baru Anda telah berhasil didaftarkan pada sistem DSN.</span><br>
					<div class="d-block text-center my-4">`
						data.forEach(akun => {
							this.msgSuccess += `
								<div class="d-block mb-2">
									<span class="d-block"><span style="display: inline-block;">Nama Mitra</span> : <strong>${akun.name}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Mitra</span> : <strong>${akun.code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Sponsor</span> : <strong>${akun.sponsor_network_code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Kode Upline</span> : <strong>${akun.upline_network_code}</strong></span>
									<span class="d-block"><span style="display: inline-block;">Posisi Jaringan</span> : <strong>${akun.position}</strong></span>
								</div>`
						})
				this.msgSuccess += `</div>
					Segera login ke website <a href="${this.voUrlOrigin}">${this.voUrlhost}/</a> untuk dapat mengakses akun tersebut. Salam sukses bersama <strong>DSN!</strong>
				`
	
				this.$refs.modalSuccess.modalShow()
			}
		},

		checkLocation() {
			const base_url = window.location.origin
			if (base_url === 'http://office.dsn-world.com' || base_url === 'https://office.dsn-world.com') {
				this.voUrlOrigin = 'https://office.dsn-world.com'
				this.voUrlhost = 'office.dsn-world.com'
			} else {
				this.voUrlOrigin = 'https://dsn-vo.esoftdream.co.id'
				this.voUrlHost = 'dsn-vo.esoftdream.co.id'
			}
		}
	},

	async created() {
		this.loaderData = await true
		await this.checkCloneStatus()
		await this.getData()
		await this.checkLocation()

		if (this.$route.query.sponsor !== undefined) {
			this.params.sponsor_network_code = await this.$route.query.sponsor
			this.getMitraSponsorName(this.$route.query.sponsor, 'input')
		} 
		
		if (this.$route.query.upline !== undefined) {
			this.params.upline_network_code = await this.$route.query.upline
			this.getMitraUplineName(this.$route.query.upline, 'input')
		}
		if (this.$route.query.pos !== undefined) {
			this.params.position = await this.$route.query.pos
		}

		// this.tempRegister = [
		// 	{
		// 		name: 'Esoftdream',
		// 		code: 'DSN1000001-1',
		// 		sponsor_network_code: 'DSN1000001',
		// 		upline_network_code: 'DSN1000001',
		// 		position: 'Kanan'
		// 	}
		// ]

		this.pageTitle = await 'Kloning Akun Mitra'
		await this.$store.dispatch('setPageTitle', this.pageTitle)
	},
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}
</style>